import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import axios from "axios";
import { request, sleep } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { getFullNameUser } from "@/js/user/user.js";
import { listUserGroups } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "AdminPaymentLinkDrawer",
  components: {
    Confirm: Confirm
  },
  props: {
    loggedUserData: Object,
    isShown: {
      type: Boolean,
      default: false
    },
    dialog: Boolean,
    order: Object,
    payment: Object
  },
  data: function data() {
    return {
      drawer: false,
      drawerWidth: "45%",
      isStatelessDrawer: true,
      isValidating: false,
      steps: [],
      defaultSteps: [],
      currentStep: 1,
      users: [],
      maxAmount: 0.0,
      paymentLink: {
        id: null,
        userId: null,
        currency: "EUR",
        amount: 0.0,
        stripeUrl: null
      },
      form: {
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }]
      },
      isLinkCreating: false,
      createPaymentLinkToken: null,
      fetchPaymentLinkToken: null,
      deletePaymentLinkToken: null,
      sendPaymentLinkToken: null,
      isCopyingToClipboard: false,
      rules: formRules
    };
  },
  computed: {
    isInvalidMainForm: function isInvalidMainForm() {
      if (!this.paymentLink.userId) return true;
      if (!this.paymentLink.stripeUrl) return true;
      return false;
    },
    errorsMainForm: function errorsMainForm() {
      if (this.isInvalidMainForm) {
        var errors = [];
        if (!this.paymentLink.userId) errors.push("You must choose the customer who pays.");
        if (!this.paymentLink.stripeUrl) errors.push("You must generate the payment link.");
        return errors;
      }
      return null;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    }
  },
  watch: {
    isShown: function () {
      var _isShown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(visible) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.drawer = visible;
              this.closureAttempt = 0;
              if (visible) {
                if (!this.defaultSteps.length) {
                  this.defaultSteps = _toConsumableArray(this.steps.map(function (x) {
                    return _objectSpread({}, x);
                  }));
                }
                this.initStep();
                this.fetchUsers();
                this.setPaymentDatas();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isShown(_x) {
        return _isShown.apply(this, arguments);
      }
      return isShown;
    }(),
    currentStep: function currentStep(_currentStep) {
      this.drawerWidth = "45%";
    }
  },
  updated: function updated() {
    this.closureAttempt++;
  },
  methods: {
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    initStep: function initStep() {
      var stepCount = 1;
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "link",
        title: "Generate payment link",
        inf: "fill in the payment information"
      }, {
        id: stepCount + 1,
        key: "synthesis",
        title: "Synthesis"
      }]);
      this.currentStep = 1;
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    fetchUsers: function fetchUsers() {
      var _this2 = this;
      this.users = [];
      if (this.payment) {
        var _this$payment$inbound, _this$payment$inbound2;
        this.users.push({
          id_user: this.payment.user.id_user,
          full_name: getFullNameUser(this.payment.user) + " " + listUserGroups.find(function (x) {
            return x.id == _this2.payment.user.user_group.toUpperCase();
          }).name + " (" + this.payment.user.login + ")",
          email: this.payment.user.login,
          company: this.payment.user.company_name,
          default_currency: this.payment.user.default_currency,
          active: this.payment.user.active
        });
        if ((_this$payment$inbound = this.payment.inboundDelivery) !== null && _this$payment$inbound !== void 0 && (_this$payment$inbound = _this$payment$inbound.consultant) !== null && _this$payment$inbound !== void 0 && _this$payment$inbound.id_user && ((_this$payment$inbound2 = this.payment.inboundDelivery) === null || _this$payment$inbound2 === void 0 || (_this$payment$inbound2 = _this$payment$inbound2.consultant) === null || _this$payment$inbound2 === void 0 ? void 0 : _this$payment$inbound2.id_user) != this.payment.user.id_user) {
          this.users.push({
            id_user: this.payment.inboundDelivery.consultant.id_user,
            full_name: getFullNameUser(this.payment.inboundDelivery.consultant) + " " + listUserGroups.find(function (x) {
              return x.id == _this2.payment.inboundDelivery.consultant.user_group.toUpperCase();
            }).name + " (" + this.payment.inboundDelivery.consultant.login + ")",
            email: this.payment.inboundDelivery.consultant.login,
            company: this.payment.inboundDelivery.consultant.company_name,
            default_currency: this.payment.inboundDelivery.consultant.default_currency,
            active: this.payment.inboundDelivery.consultant.active
          });
        }
      } else {
        this.users.push({
          id_user: this.order.user.id_user,
          full_name: getFullNameUser(this.order.user) + " " + listUserGroups.find(function (x) {
            return x.id == _this2.order.user.user_group.toUpperCase();
          }).name + " (" + this.order.user.login + ")",
          email: this.order.user.login,
          company: this.order.user.company_name,
          default_currency: this.order.user.default_currency,
          active: this.order.user.active
        });
      }
    },
    setPaymentDatas: function setPaymentDatas() {
      this.paymentLink.id = null;
      this.paymentLink.stripeUrl = null;
      if (this.payment) {
        this.paymentLink.currency = this.payment.currency;
        this.paymentLink.amount = this.payment.amount;
        this.paymentLink.userId = this.payment.user.id_user;
        this.paymentLink.paymentId = this.payment.id;
        this.maxAmount = this.payment.amount;
      } else {
        this.paymentLink.currency = this.order.currency;
        this.paymentLink.amount = this.order.total_amount_currency_include_credit_notes;
        this.paymentLink.userId = this.order.user.id_user;
        this.paymentLink.orderId = this.order.id_order;
        this.maxAmount = this.order.total_amount_currency_include_credit_notes;
      }
    },
    createPaymentLink: function createPaymentLink() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$createPaymentL;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLinkCreating = true;
              (_this3$createPaymentL = _this3.createPaymentLinkToken) === null || _this3$createPaymentL === void 0 || _this3$createPaymentL.cancel();
              _this3.createPaymentLinkToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/payment/link", "post", _this3.paymentLink, true, "api", null, _this3.createPaymentLinkToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.isLinkCreating = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to create payment link.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              response = _context2.sent;
              if (!response) {
                _context2.next = 12;
                break;
              }
              _this3.paymentLink.id = +response.data.value;
              _context2.next = 11;
              return _this3.fetchPaymentLink();
            case 11:
              _this3.isLinkCreating = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchPaymentLink: function fetchPaymentLink() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$fetchPaymentLi;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              (_this4$fetchPaymentLi = _this4.fetchPaymentLinkToken) === null || _this4$fetchPaymentLi === void 0 || _this4$fetchPaymentLi.cancel();
              _this4.fetchPaymentLinkToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 5;
              return request("/v1/payment/link/".concat(_this4.paymentLink.id), "get", null, true, "api", null, _this4.fetchPaymentLinkToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch payment link.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 5:
              response = _context3.sent;
              if (response) {
                _this4.paymentLink = _objectSpread(_objectSpread({}, _this4.paymentLink), response.data.value);
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    deletePaymentLink: function deletePaymentLink() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$deletePaymentL, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.paymentLink.id) {
                _context4.next = 6;
                break;
              }
              (_this5$deletePaymentL = _this5.deletePaymentLinkToken) === null || _this5$deletePaymentL === void 0 || _this5$deletePaymentL.cancel();
              _this5.deletePaymentLinkToken = axios.CancelToken.source();
              _this = _this5;
              _context4.next = 6;
              return request("/v1/payment/link/".concat(_this5.paymentLink.id), "delete", null, true, "api", null, _this5.deletePaymentLinkToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete payment link.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    sendPaymentLink: function sendPaymentLink() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$sendPaymentLin, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this6.paymentLink.id) {
                _context5.next = 6;
                break;
              }
              (_this6$sendPaymentLin = _this6.sendPaymentLinkToken) === null || _this6$sendPaymentLin === void 0 || _this6$sendPaymentLin.cancel();
              _this6.sendPaymentLinkToken = axios.CancelToken.source();
              _this = _this6;
              _context5.next = 6;
              return request("/v1/payment/link/".concat(_this6.paymentLink.id), "put", null, true, "api", null, _this6.sendPaymentLinkToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to send payment link.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    acknowledgeValidation: function acknowledgeValidation() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.$emit("validate", true, function () {
                _this7.$emit("close", true);
                _this7.isValidating = false;
                _this7.$toasted.show("Payment link succesfully sent.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    validateMain: function validateMain() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.$refs.confirm.open("Payment link", "Are you sure to send the payment link?");
            case 2:
              isConfirmed = _context7.sent;
              if (!isConfirmed) {
                _context7.next = 8;
                break;
              }
              _this8.isValidating = true;
              _context7.next = 7;
              return _this8.sendPaymentLink();
            case 7:
              _this8.acknowledgeValidation();
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    close: function close() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isConfirmed = true;
              if (!_this9.paymentLink.id) {
                _context8.next = 5;
                break;
              }
              _context8.next = 4;
              return _this9.$refs.confirm.open("Cancel payment link", "Are you sure you want to cancel the payment link generated ?");
            case 4:
              isConfirmed = _context8.sent;
            case 5:
              if (!isConfirmed) {
                _context8.next = 15;
                break;
              }
              if (!_this9.paymentLink.id) {
                _context8.next = 9;
                break;
              }
              _context8.next = 9;
              return _this9.deletePaymentLink();
            case 9:
              _this9.currentStep = 1;
              _this9.steps = _toConsumableArray(_this9.defaultSteps.map(function (x) {
                return _objectSpread({}, x);
              }));
              _this9.isStatelessDrawer = false;
              _this9.drawer = false;
              _this9.$emit("close", true);
              _this9.isStatelessDrawer = true;
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this10 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this10.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    }
  }
};